export const koreaCommonTestSet: string[] = [
  "경기도에 있는 시 이름",
  "강원도에 있는 시 이름",
  "충청도에 있는 시 이름",
  "국내 섬 이름",
  "역대 대한민국 대통령",
  "국내 광역시",
  "서울에 있는 구",

  "국내 아파트 브랜드 이름",
  "현대/기아차 SUV 차량",
  "현대 세단 챠량",
  "KTX 정차역",
  "서울 지하철 2호선 역",
  "경기도에 있는 대학교",
  "스마트폰 제조사",
]